export default "__VITE_ASSET__BFG$b8A5__"